import styled from '@emotion/styled';
import { FAQLIST } from 'constants/FAQLIST';
import FAQItem from './FAQItem';
import {
  BlockContentWrapper,
  BlockWrapper,
  BlockHeader,
  BlockTitle,
  BackgroundImage,
} from '../Block.styled';

type Props = {
  id: string;
};

const FAQ = (props: Props) => {
  return (
    <PadBlockWrapper id={props.id}>
      <BackgroundImage
        src='/images/background/circle2.png'
        top={120}
        left={100}
        size={125}
      />
      <BackgroundImage
        src='/images/background/circle.png'
        top={200}
        left={230}
        size={73}
      />
      <BackgroundImage
        src='/images/background/planet2.png'
        bottom={180}
        right={-30}
        size={213}
      />
      <BlockHeader>
        <BlockTitle>FAQ</BlockTitle>
      </BlockHeader>
      <BlockContentWrapper>
        <FQAWrapper>
          {FAQLIST.map((item, idx) => (
            <FAQItem key={String(idx)} index={idx} {...item} />
          ))}
        </FQAWrapper>
      </BlockContentWrapper>
    </PadBlockWrapper>
  );
};

const PadBlockWrapper = styled(BlockWrapper)`
  padding-bottom: 300px;
  padding-right: 360px;
  padding-left: 360px;

  @media (max-width: 1600px) {
    padding-right: 240px;
    padding-left: 240px;
  }

  @media (max-width: 1350px) {
    padding-right: 120px;
    padding-left: 120px;
  }

  @media (max-width: 1100px) {
    padding-right: 60px;
    padding-left: 60px;
  }

  @media (max-width: 992px) {
    padding-right: 30px;
    padding-left: 30px;
  }

  @media (max-width: 576px) {
    padding-right: 16px;
    padding-left: 16px;
  }
`;
const FQAWrapper = styled.section`
  width: 100%;
  max-width: 1150px;

  height: 100%;
`;

export default FAQ;
